const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');

export default [
    {
        path: '/stores',
        name: 'StoresPage',
        component: Index
    },
    {
        path: '/new-store',
        name: 'NewStorePage',
        component: CreatePage
    },
    {
        path: '/store/:id',
        component: ViewPage
    }
]